import React, { useEffect, useState } from 'react';
import { List, Empty, Tag } from 'antd';
import 'moment/locale/ru';
import { createUseStyles } from 'react-jss'

import Icofont from 'react-icofont';

import uuid from 'react-uuid';
import { errorCatch, GET, If, JSXMap, useAuth } from 'fennec-ui';
import { MoreOutlined } from '@ant-design/icons';
import { DropdownMobile } from 'fennec-ui';
import moment from 'moment';
import { Modal, Toast } from 'antd-mobile';
import { useSelector } from 'react-redux';
import Nl2Br from '../../../common/Nl2br';

var _ = require('lodash');

const useStyles = createUseStyles({
    promoButton: {
        width: "125px",
        fontSize: "14px",
        height: "40px",
        '&.am-button::before': {
            border: "none!important"
        }
    },
    selectPeople: {
        paddingBottom: "5px",
        width: "100%",
        '& .ant-input-prefix': {
            marginRight: "11px"
        },
        '& .ant-input-affix-wrapper': {
            padding: "4px 0px"
        },
        '& .am-list .am-list-body::before': {
            backgroundColor: "transparent"
        },
        '& .am-list .am-list-body::after': {
            backgroundColor: "transparent"
        }
    },
    listMeta: {
        '& .ant-list-item-meta-title': {
            marginBottom: "0"
        },
    },
    itemsListUsluga: {
        '& .ant-list .ant-list-item': {
            borderBottom: "1px solid #e1e1e1",
            alignItems: "flex-start"
        },
    },
    itemsOrderUsluga: {
        '& .ant-list-item': {
            alignItems: "flex-start"
        },
    },
    promo: {
        '& .ant-input-affix-wrapper': {
            paddingLeft: "0px",
        },
        '&': {
            borderBottom: "1px solid darkblue",
        },
        '&:hover': {
            borderBottom: "2px solid darkblue",
        },
    },
    appendButton: {
        '&.am-list-item': {
            width: "100%",
            // backgroundColor: "#d9d9d9",
            boxShadow: "0px 1px 3px 0px rgba(141,141,141,0.74)",
            fontWeight: 500,
            textAlign: "center",
            backgroundColor: "#f1f1f1",
            borderRadius: "5px",
            padding: "0 5px"
        },
        '&.am-list-item .am-list-line-multiple': {
            padding: "5px 13px 5px 5px"
        },
        '&.am-list-item .am-list-line-multiple .am-list-content': {
            paddingTop: "2px",
        }
        // '&.ant-btn:hover': {
        //     color: "#000",
        //     // background: #fff;
        //     boxShadow: "0px 2px 4px 0px rgba(141,141,141,0.74)",
        //     borderColor: "#d9d9d9",
        // },
        // '&.ant-btn:focus': {
        //     color: "#000",
        //     // background: #fff;
        //     boxShadow: "0px 2px 4px 0px rgba(141,141,141,0.74)",
        //     borderColor: "#d9d9d9",
        // }
    },
    peopleInput: {
        '&.am-list-item.am-input-item': {
            height: "25px",
            minHeight: "25px",
            paddingLeft: "0px"
        },
        '&.am-list-item .am-input-label': {
            fontSize: "14px",
            width: "auto",
        },
        '&.am-list-item .am-input-control input': {
            fontSize: "14px",
            fontStyle: "italic",
        },
        '&.am-list-item .am-list-line': {
            paddingRight: "0px"
        }
    },
    listItem: {
        '&.am-list-item': {
            paddingLeft: "5px"
        },
        '&.am-list-item .am-list-line': {
            paddingRight: "5px"
        }
    },
    listRadioItem: {
        '&.am-list-item .am-list-line .am-list-content': {
            fontSize: "14px"
        },
        '&.am-list-item': {
            paddingLeft: "5px"
        },
        '&.am-list-item .am-list-line': {
            paddingRight: "5px"
        }
    },
    categoryPicker: {
        '& .am-picker-popup-title': {
            fontSize: "13px"
        },
        '& .am-picker-col-indicator': {
            // height: "55px"
        },
        '& .am-picker-col-content': {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
        },
        '& .am-picker-col-item': {
            fontSize: "13px",
            // height: "35px",
            lineHeight: "14px",
            whiteSpace: "break-spaces",

            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
        },
        '& .am-picker-col-item-selected': {
            fontSize: "13px",
            fontWeight: "500"
        }
    },
    categoryPickerListItem: {
        // '&.am-list-item': {
        //     paddingLeft: "0px",
        //     minHeight: "32px"
        // },
        '&.am-list-item .am-list-line .am-list-arrow-horizontal': {
            visibility: "hidden"
        },
        // '&.am-list-item .am-list-line .am-list-content': {
        //     fontSize: "14px",
        //     paddingTop: "3px",
        //     paddingBottom: "3px",
        // },

        '& .am-list-line': {
            display: "block",
        },
        '&.am-list-item .am-list-line .am-list-content': {
            fontSize: "14px",
            paddingBottom: "0px",
        },
        '&.am-list-item .am-list-line .am-list-arrow': {
            position: "absolute",
            right: "0",
            top: "8px",
        },
        // '&.am-list-item .am-list-line .am-list-extra': {
        //     textAlign: "left",
        //     paddingTop: "0px",
        //     paddingBottom: "0px"
        // },
        '&.am-list-item': {
            paddingLeft: "0px"
        },
        '&.am-list-item .am-list-line': {
            paddingRight: "0px"
        },
        '&.am-list-item .am-list-line::after': {
            backgroundColor: "transparent!important"
        },
        '&.am-list-item .am-list-line .am-list-extra': {
            fontSize: "13px",
            textAlign: "left",
            paddingTop: "0px",
            paddingBottom: "0px",
            whiteSpace: "break-spaces",
            // whiteSpace: "initial"
        }
    },
    // checkbox: {
    //     '& .am-checkbox .am-checkbox-inner': {
    //         right: "4px"
    //     }
    // }
})


const Header = ({ icon, title, style }) => {
    return (<span>
        <Icofont icon={icon} style={style} />
        <span>{title}</span>
    </span>);
};
const SingleHeader = () => {
    return (<Header icon="user-alt-3" title="Одиночный" style={{ color: "cadetblue", fontSize: "13px", paddingRight: "6px" }} />);
};
const FemaleHeader = () => {
    return (<Header icon="businesswoman" title="Женский" style={{ color: "red", fontSize: "16px", paddingRight: "6px" }} />);
};
const MaleHeader = () => {
    return (<Header icon="businessman" title="Мужской" style={{ color: "blue", fontSize: "16px", paddingRight: "6px" }} />);
};
const SelectCategory = (props) => {
    const { value } = props;
    if (!value || !value.kategoriya) {
        return (<></>);
    }
    return (<span>
        <span> - </span>
        <span style={{ fontStyle: "italic" }}>
            <a href="#">{_.get(value, "kategoriya.kategoriya.tantsevalnayaDistsiplina.nazvanie")} / {_.get(value, "kategoriya.kategoriya.kategoriyaUchastnikov.nazvanie")}</a>
        </span>
    </span>);
};
const SelectPeople = (props) => {
    const classes = useStyles();
    const { data, prefix, value } = props;
    const display = (object) => {
        if (object === undefined) {
            return <span>Укажите участника!</span>;
        }
        if (object) {
            if (object.polzovatelStrokoi) {
                return <span>{object.polzovatelStrokoi}</span>;
            }
            if (object.polzovatel) {
                return <span>{object.polzovatel.firstname + " " + object.polzovatel.lastname}</span>;
            }
            return <span>Укажите участника!</span>;
        }
        return <></>;
    };
    const triggerFunc = React.useMemo(() => (click) => (<Tag color={(value === undefined) ? "red" : ""} onClick={click}>
        {display(value)}
    </Tag>), [value]);
    // const filteredValue = (value && value.okazannieUslugiPolzovatelyamUchastik) ? value.okazannieUslugiPolzovatelyamUchastik.filter(i => i.uslugaKlientu.yacheikaUsluga.prilozhenieID) : undefined;
    return (<div className={classes.selectPeople}>
        <div>
            {prefix}
            <span style={{ paddingLeft: "10px" }}>{triggerFunc(() => { })}</span>
        </div>
        {!!value && <Services data={data} value={value.okazannieUslugiPolzovatelyamUchastik} />}
    </div>);
};
const SelectPartner = (props) => {
    const auth = useAuth()
    const { item, value, onChange, data } = props;
    const user = useSelector(state => state.home.user);

    const display = (object) => {
        if (!object) {
            return <span>Укажите {(value?.tipTDID === 1) ? "ассистента" : "партнера"}!</span>;
        }
        if (object) {
            return <span>{object.firstname + " " + object.lastname}</span>;
        }
        return <></>;
    };

    return (<div style={{ display: "flex", gap: "5px" }}>
        <div style={{ fontStyle: "italic" }}> - {(value?.tipTDID === 1) ? "ассистент" : "партнер"} - </div>
        <div>
            {display(value?.partner)}
        </div>
    </div>);
};
const Services = (props) => {
    const auth = useAuth();
    const { value, data } = props;
    const find = (data, i) => {
        let o = (data) ? data.find(e => e.ID === i.uslugaKlientuID) : undefined;
        return o;
    };
    return (<div style={{ paddingTop: "3px", fontSize: "13px" }}>
        {(!!value) && JSXMap(value, (i, idx) => <div key={idx}>
            <div>
                <span>- {i.uslugaKlientu.yacheikaUsluga.nazvanie}</span>
                <SelectCategory auth={auth} value={i} />
                {(i?.tipTDID === 1 || i?.tipTDID === 2) && <div style={{ fontSize: "13px" }}>
                    <SelectPartner
                        auth={auth}
                        item={find(data, i)}
                        value={i}
                        data={data}
                    // onChange={(v) => onPartnerChange(v, i)}
                    />
                </div>}
            </div>
        </div>)}
    </div>);
};
const Male = (props) => {
    const auth = useAuth();
    const { item, index, value } = props;
    const gender = 1;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            gender={gender}
            prefix={<MaleHeader />}
            item={item}
            index={index}
            value={value} />
    </div>);
};
const Female = (props) => {
    const auth = useAuth();
    const { item, index, value } = props;
    const gender = 2;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            gender={gender}
            item={item}
            index={index}
            prefix={<FemaleHeader />}
            value={value} />
    </div>);
};
const Single = (props) => {
    const auth = useAuth();
    const { item, index, value } = props;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            prefix={<SingleHeader />}
            item={item}
            index={index}
            value={value} />
    </div>);
};
const SingleByGender = (props) => {
    const { auth, item, index, value, onChange, onChangeSilent, usluga } = props;
    let genderID = value?.polzovatel?.genderID || value?.genderID;
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            prefix={(genderID == 1) ? <MaleHeader /> : (genderID == 2) ? <FemaleHeader /> : <Header icon="user-alt-3" title="" style={{ color: "cadetblue", fontSize: "13px", paddingRight: "4px" }} />}
            item={item}
            gender={genderID}
            index={index}
            value={value} />
    </div>);
};
const RenderCartItem = (props) => {
    const auth = useAuth();
    const { item, index } = props;
    const description = (<div>
        {(!!item.uslugaNaMeropriyatii && !!item.uslugaNaMeropriyatii.opisanie) && <div style={{ fontSize: "13px" }}>{item.uslugaNaMeropriyatii.opisanie}</div>}
    </div>);
    const getPeopleByGender = (array, genderID) => {
        if (!array) return;
        for (let i = 0; i < array.length; i++) {
            const element = array[i];
            if ((element.polzovatel && element.polzovatel.genderID === genderID) ||
                (element.genderID && element.genderID === genderID) ||
                (element.polzovatelStrokoi)) {
                return element;
            }
        }
    };
    return (<>
        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <div style={{ flex: "auto", width: "100%" }}>
                <div style={{ whiteSpace: "initial", fontSize: "14px" }}>
                    <div style={{ fontWeight: "500" }}>{item.uslugaNaMeropriyatii.nazvanie}</div>
                    <div style={{ fontWeight: "300" }}>{description}</div>
                </div>
                <div style={{ alignSelf: "flex-start", textAlign: "start" }}>
                    <div style={{ padding: "5px 0px" }}>
                        {(item.uslugaNaMeropriyatii.vidUslugiID === 1) &&
                            <Male auth={auth} item={item} index={index}
                                value={getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 1)} />
                        }
                        {(item.uslugaNaMeropriyatii.vidUslugiID === 2) &&
                            <Female auth={auth} item={item} index={index}
                                value={getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 2)} />
                        }
                        {(item.uslugaNaMeropriyatii.vidUslugiID === 3) &&
                            <div style={{ display: "flex", justifyContent: "flex-start" }}>
                                <div>
                                    <div style={{ paddingBottom: "5px" }}>
                                        <SingleByGender auth={auth} item={item} index={index}
                                            value={_.get(item, "polzovateliVZakazeTovarVZakaze[0]")} />
                                    </div>
                                    <div style={{ paddingBottom: "5px" }}>
                                        <SingleByGender auth={auth} item={item} index={index}
                                            value={_.get(item, "polzovateliVZakazeTovarVZakaze[1]")} />
                                    </div>
                                </div>
                            </div>}
                        {(item.uslugaNaMeropriyatii.vidUslugiID === 4) &&
                            <Single auth={auth} item={item} index={index}
                                value={_.get(item, "polzovateliVZakazeTovarVZakaze[0]")} />
                        }
                    </div>
                </div>
                {(item?.uslugaNaMeropriyatii?.vklyuchitKommentarii == true) && <div>
                    <div className='bg bg-transparent border-grey' style={{ fontSize: "12px", textAlign: "left", margin: "5px 0" }}>
                        <div style={{ fontSize: "11px", color: "rgba(0,0,0,.65)", display: "flex", justifyContent: "space-between" }}>
                            <div><i className="fa fa-comments-o"></i> Комментарий покупателя</div>
                            {/* <div><i className="fa fa-pencil-square-o"></i></div> */}
                        </div>
                        <div><Nl2Br text={item?.kommentarii} /></div>
                    </div>
                </div>}
            </div>
            <div style={{ flex: "130px" }}>
                <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", fontWeight: "500", fontSize: "15px" }}>
                    <div style={(item.tsena !== item.tsenaDoPromokoda) ? { textDecoration: "line-through" } : {}}>{Number((item.tsenaDoPromokoda).toFixed(2)).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}</div>
                    {(item.tsena !== item.tsenaDoPromokoda) && <div style={{ color: "red" }}>{Number((item.tsena).toFixed(2)).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}</div>}
                </div>
            </div>
        </div>
    </>)
};
function CollectionList(props) {
    const classes = useStyles();
    const auth = useAuth();
    const { zakaz, loading } = props;

    return (
        <div>
            <List
                className={classes.itemsOrderUsluga}
                locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет абонементов" /> }}
                style={{ borderBottom: "1px solid #f0f0f0" }}
                itemLayout="horizontal"
                dataSource={(zakaz) ? zakaz.tovariVZakazeZakaz : []}
                loading={loading}
                renderItem={(item, index) => (
                    <List.Item>
                        <RenderCartItem auth={auth} uuid={uuid()} item={item} index={index} zakaz={zakaz} promo={zakaz.promokod} />
                    </List.Item>
                )}
            />
            {!loading && <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "500", fontSize: "16px", padding: "10px 0px 0px 0px" }}>
                <div>
                    ИТОГО:
                </div>
                {(zakaz && zakaz.obshchayaSumma) && <div>
                    {Number((zakaz.obshchayaSumma).toFixed(2)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
                </div>}
            </div>}
        </div>
    );
}

export default function ZakazPreview(props) {
    const auth = useAuth();
    const { object, options } = props;
    const [zakaz, setZakaz] = useState({});
    const [loading, setLoading] = useState(false);

    const { setCollectionItem } = options;

    useEffect(() => {
        if (object) {
            setLoading(true);
            GET(auth, `/api/zakaz/bynumber/${object.nomerZakaza}`, ({ data }) => {
                if (data) {
                    setZakaz(data);
                }
                setLoading(false);
            }, (err) => errorCatch(err, setLoading(false)))
        }
    }, [object]);

    // /ekvairing/pay-keeper/revoke/{ekvairingID}
    // const ekvairingRevoke = React.useMemo(() => (ekvairingID) => {
    //     Modal.alert('Отменить заказ?', '', [
    //         { text: 'Нет', onPress: () => { }, style: 'default' },
    //         {
    //             text: 'Да', onPress: () => {
    //                 setLoading(true);
    //                 GET(auth, `/ekvairing/pay-keeper/revoke/${ekvairingID}`,
    //                     ({ data }) => {
    //                         let o = { ...zakaz, ekvairingZakaz: (data) ? [data] : undefined }
    //                         setCollectionItem(o);
    //                         // update();
    //                         setLoading(false);
    //                     }, (err) => errorCatch(err, () => setLoading(false)));
    //             }
    //         },
    //     ]);
    // }, []);
    // /ekvairing/checkstatusnotpaidekvairing/{zakazID}
    const ekvairingCheckstatusnotpaidekvairing = React.useMemo(() => (zakazID) => {
        setLoading(true);
        GET(auth, `/ekvairing/checkstatusnotpaidekvairing/${zakazID}`,
            ({ data }) => {
                let o = { ...zakaz, ...data.zakaz, ekvairingZakaz: (data) ? [data] : undefined }
                setCollectionItem(o);
                // update();
                setLoading(false);
                Toast.show({
                    icon: 'success',
                    content: 'Статус заказа обновлен!'
                })
            }, (err) => errorCatch(err, () => setLoading(false)));
    }, []);

    const vozvrat = React.useMemo(() => (zakazID) => {
        GET(auth, `/api/zakaz/summa-vozvrata/${zakazID}`,
            ({ data }) => {

                Modal.confirm({
                    title: 'Выполнить возврат средств?',
                    content: `Сумма в размере ${Number(data.toFixed(2)).toLocaleString('ru', { minimumFractionDigits: 2 })} руб. будет возвращена клиенту.`,
                    confirmText: "Да",
                    cancelText: "Нет",
                    onConfirm: () => {
                        setLoading(true);
                        GET(auth, `/api/zakaz/vozvrat/${zakazID}`,
                            ({ zakaz }) => {
                                setCollectionItem(zakaz);
                                // update();
                                setLoading(false);
                            }, (err) => errorCatch(err, () => setLoading(false)));
                    },
                })

                setLoading(false);
            }, (err) => errorCatch(err, () => setLoading(false)));

    }, [zakaz, options]);

    const pay = (path) => {
        window.location.href = path
    };
    const buttons = (item) => {
        if (item) {
            let jsx = []
            if (item.statusID == 3) {
                jsx.push(
                    {
                        auth: props.auth,
                        object: item,
                        title: "Отправить на почту",
                        action: (values, unlock, close) => {
                            Modal.confirm({
                                title: 'Отправка заказа на почту',
                                content: 'Отправить письмо с заказом на Ваш адрес электронной почты?',
                                confirmText: "Да",
                                cancelText: "Нет",
                                onConfirm: () => {
                                    setLoading(true);
                                    GET(auth, `/api/zakaz/send-email/${object.ID}`, () => {
                                        setLoading(false);
                                    }, (err) => errorCatch(err, setLoading(false)))
                                    close();
                                },
                            })
                        },
                    });
            }

            if (item.obshchayaSumma > 0 && item.statusID == 3 && moment().isBefore(moment(item.meropriyatie.nachaloSorevnovaniya))) {
                jsx.push({
                    auth: props.auth,
                    object: item,
                    title: "Возврат",
                    action: (values, unlock, close) => { vozvrat(item.ID); close(); },
                })
                // return (<DropdownMobile
                //     titles={{
                //         header: (item) ? "Заказ №" + item.nomerZakaza + " от " + moment(item.dataZakaza).format("DD.MM.YYYY HH:mm:ss") : ""
                //     }}
                //     icon={<span><MoreOutlined />Действия</span>}
                //     buttonStyle={{ border: "none" }}
                //     items={(store) => [
                //         {
                //             auth: props.auth,
                //             object: item,
                //             title: "Возврат",
                //             action: (values, unlock, close) => { vozvrat(item.ID); close(); },
                //         },
                //     ]} />)
            }

            if (item.ekvairingZakaz && item.ekvairingZakaz[0]) {
                let paymentStateID = item.ekvairingZakaz[0].paymentStateID;
                if (paymentStateID == 2) {
                    jsx.push({
                        auth: props.auth,
                        object: item,
                        title: "Обновить статус",
                        action: (values, unlock, close) => { ekvairingCheckstatusnotpaidekvairing(item.ID); close(); },
                    })
                    jsx.push({
                        auth: props.auth,
                        object: item,
                        title: "Оплатить заказ",
                        action: (values, unlock, close) => { pay(item.ekvairingZakaz[0].paymentUrl); },
                    })
                    // return (<DropdownMobile
                    //     titles={{
                    //         header: (item) ? "Заказ №" + item.nomerZakaza + " от " + moment(item.dataZakaza).format("DD.MM.YYYY HH:mm:ss") : ""
                    //     }}
                    //     icon={<span><MoreOutlined />Действия</span>}
                    //     buttonStyle={{ border: "none" }}
                    //     items={(store) => [
                    //         {
                    //             auth: props.auth,
                    //             object: item,
                    //             title: "Обновить статус",
                    //             action: (values, unlock, close) => { ekvairingCheckstatusnotpaidekvairing(item.ID); close(); },
                    //         },
                    //         {
                    //             auth: props.auth,
                    //             object: item,
                    //             title: "Оплатить заказ",
                    //             action: (values, unlock, close) => { pay(item.ekvairingZakaz[0].paymentUrl); close(); },
                    //         },
                    //         // {
                    //         //     auth: props.auth,
                    //         //     object: item,
                    //         //     title: "Отменить заказ",
                    //         //     action: (values, unlock, close) => { ekvairingRevoke(item.ekvairingZakaz[0].ID); close(); },
                    //         // },
                    //     ]} />)
                    // return ([
                    //     <Button key="0" onClick={() => ekvairingCheckstatusnotpaidekvairing(item.ID)}>Обновить статус</Button>,
                    //     <Button key="1" onClick={() => pay(item.ekvairingZakaz[0].paymentUrl)}>Оплатить заказ</Button>,
                    //     <Button key="2" onClick={() => ekvairingRevoke(item.ekvairingZakaz[0].ID)}>Отменить заказ</Button>
                    // ])
                } else if (paymentStateID == 3 && item.statusID == 1) {
                    jsx.push({
                        auth: props.auth,
                        object: item,
                        title: "Обновить статус",
                        action: (values, unlock, close) => { ekvairingCheckstatusnotpaidekvairing(item.ID); close(); },
                    })
                    // return (<DropdownMobile
                    //     titles={{
                    //         header: (item) ? "Заказ №" + item.nomerZakaza + " от " + moment(item.dataZakaza).format("DD.MM.YYYY HH:mm:ss") : ""
                    //     }}
                    //     icon={<span><MoreOutlined />Действия</span>}
                    //     buttonStyle={{ border: "none" }}
                    //     items={(store) => [
                    //         {
                    //             auth: props.auth,
                    //             object: item,
                    //             title: "Обновить статус",
                    //             action: (values, unlock, close) => { ekvairingCheckstatusnotpaidekvairing(item.ID); close(); },
                    //         },
                    //         // {
                    //         //     auth: props.auth,
                    //         //     object: item,
                    //         //     title: "Отменить заказ",
                    //         //     action: (values, unlock, close) => { ekvairingRevoke(item.ekvairingZakaz[0].ID); close(); },
                    //         // },
                    //     ]} />)
                    // return ([
                    //     <Button key="0" onClick={() => ekvairingCheckstatusnotpaidekvairing(item.ID)}>Обновить статус</Button>,
                    //     <Button key="1" onClick={() => pay(item.ekvairingZakaz[0].paymentUrl)}>Оплатить заказ</Button>,
                    //     <Button key="2" onClick={() => ekvairingRevoke(item.ekvairingZakaz[0].ID)}>Отменить заказ</Button>
                    // ])
                }
            }
            return (<DropdownMobile
                titles={{
                    header: (item) ? "Заказ №" + item.nomerZakaza + " от " + moment(item.dataZakaza).format("DD.MM.YYYY HH:mm:ss") : ""
                }}
                icon={<span><Icofont icon="navigation-menu" /> Действия</span>}
                buttonStyle={{ border: "none" }}
                items={() => jsx} />)
        }
        return (<></>);
    };

    return (<div style={{ padding: "0 10px" }}>
        {object?.promokod && <div>
            <div style={{ fontSize: "12px" }}>Промокод: <span style={{ fontWeight: "bold" }}>{object?.promokod}</span></div>
        </div>}
        <div style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "5px" }}>
            {buttons(object)}
        </div>
        {If(!!zakaz, <CollectionList auth={auth} zakaz={zakaz} promo={zakaz.promokod} loading={loading} />)}
    </div>);
}
// PaymentForm.whyDidYouRender = true
// CollectionList.whyDidYouRender = true
